import {Injectable,} from '@angular/core';
import {SMS001MainMenuInVO,} from '@pages/sms001-main-menu/sms001-main-menu-in-vo';
import {WindowService,} from '@services/index';

@Injectable({
  providedIn: 'root',
})
/*****************************************************/
/* 処　理：共通　画面遷移処理
/*
/* 概　要：メインメニュー画面へ遷移
/*
/* 更新日：2025/01/08 HARAGU 00011_SMS機能等の導入支援
/*****************************************************/
export class SmsMenuPage {

  constructor(
    private windowService: WindowService
  ) {
  }

  /**
   * SMS001：メインメニュー画面へ遷移
   *
   * @param hashId 契約情報ID(ハッシュID）
   * @param menuNo 取引メニュー番号
   * @param lng    言語区分
   *
   */
  transition(hashId: string,
             menuNo: string,
             lng:    string ): void {

    // POSTパラメータ設定
    const info001Vo: SMS001MainMenuInVO = new SMS001MainMenuInVO();
    info001Vo.hashId = hashId;
    info001Vo.menuNo = menuNo;
    info001Vo.languageType = lng;

    // 画面遷移
    this.windowService.transit<SMS001MainMenuInVO>('SMS001', info001Vo);
  }
}
